import { SevenSegment } from './SevenSegment';

window.customElements.define('seven-segment', SevenSegment);
